import { useIsVisible } from "@website/hooks/is-visible";
import { useViewPort } from "@website/hooks/viewport";
import { Chips } from "@website/ui/chips";
import { holidaysList } from "@website/ui/datepicker/components/main/holidays";
import styles from "@website/ui/datepicker/components/main/main.module.scss";
import { MainPropertiesType } from "@website/ui/datepicker/components/main/main.types";
import { Table } from "@website/ui/datepicker/components/table";
import { convertDate } from "@website/ui/datepicker/datepicker.utils";
import { dateFormat } from "@website/utils/date-format";
import { useRouter } from "next/compat/router";
import { FC, Fragment, useEffect } from "react";
export const Main: FC<MainPropertiesType> = properties => {
  const {
    type,
    calendarLocale,
    value,
    setValue,
    onChange,
    showDates,
    increaseShowDatesNumber,
    scrollReference,
    setScrollReference,
    calendarData,
    mode,
    disableLimit,
    view,
    suggestions,
    disableDates,
    isLabelTop
  } = properties;
  const router = useRouter();
  const {
    reference,
    inView
  } = useIsVisible({
    root: scrollReference,
    rootMargin: "50px"
  });
  const {
    isDesktop
  } = useViewPort();
  useEffect(() => {
    if (!isDesktop && inView && showDates.length < 12) {
      increaseShowDatesNumber();
    }
  }, [isDesktop, inView, showDates, increaseShowDatesNumber]);
  const calendarInfo = {
    selectedDate: undefined
  };
  const suggestedDates = suggestions?.filter(date => {
    const dateFrom = convertDate({
      dateTime: date?.date_from
    }, calendarLocale);
    const dateTo = convertDate({
      dateTime: date?.date_to
    }, calendarLocale);
    return dateFrom.year === showDates?.[0]?.year && dateFrom.month === showDates?.[0]?.month || dateTo.year === showDates?.[0]?.year && dateTo.month === showDates?.[0]?.month;
  }) ?? [];
  return <div className={`${styles["main"]} ${view === "mobile" ? styles["main__mobile"] : styles["main__default"]} ${styles["rtl" || "ltr"]}`}>
      <div className={`${styles["tables-container"]} ${view === "mobile" ? "" : styles["tables-container__default"]}`} ref={view === "mobile" ? setScrollReference : null} id="main-calendar">
        {showDates.map((item, index) => <Fragment key={`${item.year}_${item.month}`}>
            {index > 0 ? <div className={`${styles["divider"]} ${view === "mobile" ? styles["divider__mobile"] : styles["divider__default"]}`} /> : null}

            <Table calendarData={calendarData} calendarInfo={calendarInfo} calendarLocale={calendarLocale} disableDates={disableDates} disableLimit={disableLimit} holidays={holidaysList} isLast={showDates.length === index + 1} mode={mode} month={item.month} onChange={onChange} setValue={setValue} suggestedDates={suggestedDates} type={type} value={value} view={view} year={item.year} isLabelTop={isLabelTop} hasExtraData={calendarData && Object.values(calendarData).some(item_0 => item_0.availability > 0)} />
            {suggestedDates?.length > 0 && <div className="flex flex-col gap-1 self-start">
                <div className="flex flex-row items-center gap-4">
                  <div className="border-t-warning mt-1 border-y-8 border-r-8 border-b-transparent border-r-transparent" />
                  <div className="text-caption">بازه‌های اقامتی مشخص:</div>
                </div>
                <div className="flex flex-row flex-wrap gap-2">
                  {suggestedDates?.map(date_0 => <Chips key={`${date_0.date_from}-${date_0.date_to}`} color={value?.[0]?.dateTime === date_0?.date_from && value?.[1]?.dateTime === date_0?.date_to ? "secondary" : ""} onClick={() => {
              const dateFrom_0 = convertDate({
                dateTime: date_0.date_from
              }, calendarLocale);
              const dateTo_0 = convertDate({
                dateTime: date_0.date_to
              }, calendarLocale);
              if (calendarData[date_0?.date_from] && calendarData[date_0?.date_to] && calendarData?.[date_0?.date_from]?.state !== "disabled" && value.every(item_1 => calendarData?.[item_1?.dateTime]?.state !== "rack")) {
                setValue([{
                  year: dateFrom_0?.year,
                  month: dateFrom_0?.month,
                  day: dateFrom_0?.day,
                  dateTime: date_0?.date_from
                }, {
                  year: dateTo_0?.year,
                  month: dateTo_0?.month,
                  day: dateTo_0?.day,
                  dateTime: date_0?.date_to
                }]);
                return router?.replace({
                  query: {
                    ...router.query,
                    date_from: date_0?.date_from,
                    date_to: date_0?.date_to
                  }
                }, undefined, {
                  shallow: true,
                  scroll: false
                });
              }
            }} selected={value?.[0]?.dateTime === date_0?.date_from && value?.[1]?.dateTime === date_0?.date_to} text={`${dateFormat(date_0?.date_from, {
              locale: "fa",
              template: "dd MMMM"
            })} تا ${dateFormat(date_0?.date_to, {
              locale: "fa",
              template: "dd MMMM"
            })}`} variant={value?.[0]?.dateTime === date_0?.date_from && value?.[1]?.dateTime === date_0?.date_to ? "contained" : "outline"} />)}
                </div>
              </div>}
          </Fragment>)}
        {type === "popover" && <div className={styles["scroll-more-area"]} ref={reference} />}
      </div>
    </div>;
};